import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { LOADER_TIMEOUT_TIME, SORT_D, SORT_A, CURRENCY_SYMBOL } from "../../../../../utils/Constants";
import { showPrice, writeMyExcel, getDateInFormat, handleOffcanvasScroll, pluralText, getSelectedAddons, getDate } from "../../../../../utils/commonfunction";

import { DateRangePicker } from "rsuite";
import ReactToPrint from "react-to-print";
import { orderList, orderDetail } from "../../../services/sales.transaction.service";
import CustomPagination from "../../../../admin/common/custompagination";
import { useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import RecordNotFound from "../../../shared/recordNotFound";

export default function OrderList() {
  const { t } = useTranslation();
  const [loader, setLoader] = useState(true);
  const componentRef = useRef();

  const lowerButtonRef = useRef(null);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [orderData, setOrderData] = useState([]);
  const [page, setPage] = useState(1);
  const [offset, setOffsetPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [itemPerPage] = useState(10);
  const params = useParams();
  const [search, setSearch] = useState({});
  const [globalSearch] = useState("");
  const [orderId, setOrderId] = useState(null);
  const [detailsData, setDetailsData] = useState(null);

  const getOrderReport = () => {
    setLoader(true);
    const formData = new FormData();
    if (Object.keys(search).length) {
      formData.append("search", JSON.stringify({ ...search }));
    }
    formData.append("global_search", globalSearch);
    // Determine the page number
    let page = params.page;
    setPage(page);
    formData.append("page", page);
    formData.append("per_page", itemPerPage);
    orderList(formData)
      .then((response) => {
        setOrderData(response.data.list);
        setPage(response.data.page);
        setOffsetPage(response.data.offset);
        setTotalRecords(response.data.total_records || 0);

        setTimeout(() => {
          setLoader(false);
        }, LOADER_TIMEOUT_TIME);
      })
      .catch((error) => {
        setTimeout(() => {
          setLoader(false);
        }, LOADER_TIMEOUT_TIME);
        console.log("error ====> ", error);
      });
  };

  useEffect(() => {
    getOrderReport();
  }, [search, globalSearch, params.page]);

  /** Getting record details */
  useEffect(() => {
    if (orderId) {
      orderDetail(orderId).then((response) => {
        setDetailsData(response.data);
      }).catch((error) => {
        console.error("error ====> ", error);
      });
    }
  }, [orderId]);

  const handleExportToExcel = () => {
    // Table headers (same order as UI table, no Action column)
    const headers = [
      "Date & Time",
      "Order ID",
      "Order Type",
      "Tax Amount",
      "Service Charge",
      "Sub Total",
      "Items Count",
      "Grand Total",
    ];

    // Table rows
    const rows = orderData.map((item) => [
      getDateInFormat(item?.createdAt),
      item?.order_id || "",
      t(`order_types.${item?.order_type}`),
      `£${showPrice(item?.tax_price || 0, 2)}`,
      `£${showPrice(item?.service_charge || 0, 2)}`,
      `£${showPrice(item?.subtotal || 0, 2)}`,
      item?.ordered_items?.length || 0,
      `£${showPrice(item?.grand_total || 0, 2)}`,
    ]);

    // Export
    writeMyExcel([headers, ...rows], "order_report.xlsx");
  };

  const handleUpperButtonClick = () => {
    if (lowerButtonRef.current) {
      if (isDatePickerOpen) {
        // Close the DatePicker
        lowerButtonRef.current.close(); // Close the DatePicker programmatically
      } else {
        // Open the DatePicker
        lowerButtonRef.current.open(); // Open the DatePicker programmatically
      }
      setIsDatePickerOpen(!isDatePickerOpen); // Toggle the open/close state
    }
  };

  const handleDateChange = (value) => {
    let obj = { ...search };
    obj.createdAt = { start: value[0], end: value[1] };
    setSearch(obj);
    setIsDatePickerOpen(false); // Close the DatePicker after selection
  };

  const handleToggle = (open) => {
    setIsDatePickerOpen(open);
  };

  const handleDatePickerClose = () => {
    setIsDatePickerOpen(false); // Close the DatePicker and change the icon state
  };

  return (
    <main id="main-content">
      <div className="inner-container">
        <div className="card-outer-header d-flex justify-content-between align-items-center mb-4">
          {/* <button className='btn btn-date'><i className='ti ti-calendar'></i> 14 May 2024 <i
                            className='ti ti-chevron-down'></i></button> */}

          <div style={{ gap: "10px", display: "flex" }}>
            <div style={{ position: "relative", display: "inline-block" }}>
              {/* Upper Button */}
              <button className="btn btn-date" onClick={handleUpperButtonClick}>
                <i className="ti ti-calendar" style={{ color: "#757575" }}></i>{" "}
                <span style={{ color: "#757575" }}>
                  {search && search.createdAt && search.createdAt.start && search.createdAt.end
                    ? `${getDate(search.createdAt.start, "DD/MM/YYYY", false)} - ${getDate(search.createdAt.end, "DD/MM/YYYY", false)}`
                    : t("restaurant.sales.placeholder_date")}
                </span>{" "}
                <i className={`ti ${isDatePickerOpen ? "ti-chevron-up" : "ti-chevron-down"}`} style={{ color: "#757575" }}></i>
              </button>

              {/* Hidden DatePicker */}

              <div style={{ visibility: "hidden", position: "absolute", top: 0, left: 0 }}>
                <DateRangePicker
                  ref={lowerButtonRef}
                  classPrefix="restaurant"
                  placement="bottomStart"
                  container={() => document.body}
                  format={"dd/MM/yyyy"}
                  cleanable={false}
                  editable={false}
                  value={search.createdAt ? [new Date(search.createdAt.start), new Date(search.createdAt.end)] : null}
                  onChange={handleDateChange}
                  onToggle={handleToggle} // Handle open/close state
                  disabledDate={(date) => date > new Date()}
                  onClose={handleDatePickerClose}
                />
              </div>
            </div>

            <button
              className="btn"
              style={{ backgroundColor: "#e42373", color: "white" }}
              onClick={() => {
                let obj = { ...search };
                delete obj.createdAt;
                setSearch(obj);
              }}
            >
              {t("restaurant.sales.label_Reset_date")}
            </button>
          </div>

          <div className="card-head-group d-flex align-items-center gap-2">
            <button
              className="btn btn-black"
              onClick={() => {
                orderData?.length && handleExportToExcel();
              }}
              disabled={!orderData?.length}
            >
              <i className="ti ti-download"></i> {t("restaurant.sales.label_download")}
            </button>
            {/* <ReactToPrint
              trigger={() => (
                <button className="btn btn-black" disabled={!orderData?.length}>
                  <i className="ti ti-printer"></i> {t("restaurant.sales.label_print")}
                </button>
              )}
              content={() => componentRef.current}
            /> */}
          </div>
        </div>

        {loader ? (
          <div className="w-100">
            <Skeleton className="mb-2" height={50} count={5} />
          </div>
        ) : orderData.length ? (
          <div className="card">
            <div className="card-body">
              <div className="table-responsive" ref={componentRef}>
                <table className="table table-printable ">
                  <thead>
                    <tr>
                      <th>Date & Time</th>
                      <th>
                        Order ID
                      </th>
                      <th>
                        Order Type
                      </th>
                      <th>
                        Vat Amount
                      </th>
                      <th>
                        Service Charge
                      </th>
                      <th>
                        Sub Total
                      </th>
                      <th>
                        Items Count
                      </th>
                      <th>
                        Grand Total
                      </th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderData && orderData.length
                      ? orderData.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              <span className="text-nowrap">{getDateInFormat(item?.createdAt)}</span>
                            </td>
                            <td>
                              {/* Order ID */}
                              {item.order_id}
                            </td>

                            <td>
                              {/* Order Type (Dine-in / Takeaway / Delivery etc.) */}
                              {t(`order_types.${item?.order_type}`)}
                            </td>

                            <td>
                              {/* Tax Price */}£ {showPrice(item?.tax_price || 0, 2)}
                            </td>

                            <td>
                              {/* Service Charge */}£ {showPrice(item?.service_charge || 0, 2)}
                            </td>

                            <td>
                              {/* Service Charge */}£ {showPrice(item?.subtotal || 0, 2)}
                            </td>

                            <td>
                              {/* Count of ordered items */}
                              {item?.ordered_items?.length || 0}
                            </td>

                            <td>
                              {/* Grand Total */}£ {showPrice(item?.grand_total || 0, 2)}
                            </td>

                            <td>
                              <button
                                className="btn btn-outline-secondary btn-sm"
                                onClick={() => {
                                  setOrderId(item?._id);
                                }}
                                data-bs-toggle="offcanvas"
                                data-bs-target="#orderDetailsCanvas">
                                <i className="ti ti-eye"></i>
                              </button>
                            </td>
                          </tr>
                        );
                      })
                      : ""}
                  </tbody>
                </table>
              </div>
              <div className="table-status-info d-flex justify-content-between align-items-center">
                <span>
                  {t("restaurant.table_management.label_showing")} {offset + orderData.length} of {totalRecords} {t("restaurant.table_management.label_entries")}
                </span>
                <nav aria-label="Page navigation example" title={page}>
                  {totalRecords && totalRecords > 0 ? (
                    <CustomPagination
                      datalength={totalRecords}
                      itemperpage={itemPerPage}
                      currentPage={page}
                      custompath="page"
                      setPage={setPage}
                      pageRoute={[{ name: "settings", path: "/restaurant/sales/order" }]}
                    />
                  ) : (
                    ""
                  )}
                </nav>
              </div>
            </div>
          </div>
        ) : (
          <RecordNotFound heading="No orders found" />
        )}




        {/* ) : (
          <RecordNotFound heading="lbl_record_not_found" />
        )} */}
      </div>

      {/* modal for view  */}
      <div className="offcanvas offcanvas-end right-modal-w" id="orderDetailsCanvas" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="staticBackdropLabel">
        <div className="offcanvas-header">
          <h3 className="offcanvas-title" id="offcanvasRightLabel">
            Order Details
          </h3>
          <button type="button" className="btn btn-icon ms-auto" data-bs-dismiss="offcanvas" aria-label="Close" onClick={() => setOrderId(null)}>
            <i className="ti ti-x"></i>
          </button>
        </div>

        <div
          className="offcanvas-body"
          onScroll={(e) => {
            handleOffcanvasScroll(e, "orderDetailsCanvas");
          }}>
          <div className="view-info">
            <div className="row gap-4">
              <div className="col-md-12">
                <h4>{t("restaurant.sales.date_time_label")}:</h4>
                <p>{getDateInFormat(detailsData?.createdAt)}</p>
              </div>
              <div className="col-md-12">
                <h4>Order ID:</h4>
                <p>{detailsData?.order_id}</p>
              </div>
              <div className="col-md-12">
                <h4>Order Type:</h4>
                <p>{t(`order_types.${detailsData?.order_type}`)}</p>
              </div>
              <div className="col-md-12">
                <h4>Vat Amount:</h4>
                <p>{CURRENCY_SYMBOL} {showPrice(detailsData?.tax_price || 0)}</p>
              </div>
              <div className="col-md-12">
                <h4>Service Charge:</h4>
                <p>{CURRENCY_SYMBOL} {showPrice(detailsData?.service_charge || 0)}</p>
              </div>
              <div className="col-md-12">
                <h4>Sub Total:</h4>
                <p>{CURRENCY_SYMBOL} {showPrice(detailsData?.subtotal || 0)}</p>
              </div>
              <div className="col-md-12">
                <h4>Ordered Items:</h4>
                <div className="accordion" id="viewOrderedItemsDetails">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        {detailsData?.ordered_items?.length} {pluralText(detailsData?.ordered_items?.length, 'Item', 'Items')}
                      </button>
                    </h2>
                    <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#viewOrderedItemsDetails">
                      <div className="accordion-body p-0">
                        <ul className="list-group list-group-flush">
                          {
                            detailsData?.ordered_items?.map((item, index) => (
                              <li className="list-group-item d-flex justify-content-between align-items-center" key={index}>
                                <div>
                                  <strong>{item?.item_name}</strong>
                                  {
                                    getSelectedAddons(item)?.length > 0 ?
                                      <div className="d-flex">
                                        {
                                          getSelectedAddons(item)?.map((addon, index) => {
                                            return <span className="d-block me-2" key={index}>{addon?.item_name}</span>;
                                          })
                                        }
                                      </div>
                                      : null
                                  }
                                </div>
                                <span>
                                  x{item?.quantity}
                                </span>
                              </li>
                            ))
                          }
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <h4>{t("restaurant.sales.label_table_no")}:</h4>
                <p>{detailsData?.orderData?.table_number || "-"}</p>
              </div>
              <div className="col-md-12">
                <h4>Grand Total:</h4>
                <p>{CURRENCY_SYMBOL} {showPrice(detailsData?.grand_total || 0)}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
